// AGC: Admin badge / status pill primitive
import React from 'react'

type BadgeVariant = 'success' | 'warn' | 'danger' | 'neutral' | 'info' | 'admin'

interface AdminBadgeProps {
  variant?: BadgeVariant
  children: React.ReactNode
  className?: string
}

const VARIANT_CLASSES: Record<BadgeVariant, string> = {
  success: 'bg-success-50 text-brand-primary dark:bg-emerald-500/15 dark:text-emerald-400',
  warn: 'bg-warning-50 text-warning-700 dark:bg-yellow-500/15 dark:text-yellow-400',
  danger: 'bg-error-50 text-error-700 dark:bg-red-500/15 dark:text-red-400',
  neutral: 'bg-slate-100 text-slate-600 dark:bg-slate-500/15 dark:text-slate-300',
  info: 'bg-info-50 text-info-700 dark:bg-blue-500/15 dark:text-blue-400',
  admin: 'bg-error-50 text-error-600 dark:bg-red-500/20 dark:text-red-300',
}

export const AdminBadge: React.FC<AdminBadgeProps> = ({
  variant = 'neutral',
  className = '',
  children,
}) => (
  <span
    className={`
      inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold
      ${VARIANT_CLASSES[variant]} ${className}
    `.replace(/\s+/g, ' ').trim()}
  >
    {children}
  </span>
)
